module.exports = "<p>\n  manage works!\n</p>\n"